import React from 'react'
import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment/locale/it';

type DateInputProps = {
    format: string
    [key: string]: any
}

const DateInput = (props: DateInputProps) => {
    const [value, setValue] = React.useState<string>('');
    const [validValue, setValidValue] = React.useState<string>('');

    const updateValidValue = (s: string) => {
        setValidValue(s)
        setValue(s)
    }

    const validateInput = React.useCallback((s: string) => {
        moment(s, props.format, true).isValid() ?
            updateValidValue(s) :
            setValue(validValue)
    }, [validValue, props.format])

    React.useEffect(() => {
        validateInput(props.value)
    }, [props.value, validateInput])

    return (
        <div className={`tp-wicon-right ${props.wrapper_class_name}`} onClick={props?.openCalendar}>
            <i className="fa-solid fa-chevron-down ricon"></i>
            <input {...props} className={`form-control form-control-solid mb-3 mb-lg-0`} onChange={(e) => validateInput(e?.target?.value)} value={value} />
        </div>
    )
}

const renderDateInput = (props: any, openCalendar: any, closeCalendar: any) => (
    <DateInput format={dateFormat} {...props} style={{}} wrapper_class_name="tp-date" openCalendar={openCalendar} closeCalendar={closeCalendar} />
)

const renderTimeInput = (props: any, openCalendar: any, closeCalendar: any) => (
    <DateInput format={timeFormat} {...props} style={{}} wrapper_class_name="tp-time" openCalendar={openCalendar} closeCalendar={closeCalendar} />
)

export type DateRangeInputProps = {
    [key: string]: any
    value?: DateRangeState | TimeRangeState
    type: "daterange" | "timerange"

    onChange?: (e: any) => void
}

export type DateRangeState = {
    from: string
    to: string
}

export type TimeRangeState = {
    date: string
    from: string
    to: string
}

export const dateFormat = 'DD/MM/YYYY'
export const timeFormat = 'HH:mm'

function getStateFromValue(value?: DateRangeState | TimeRangeState) {
    return {
        date: (value as TimeRangeState)?.date || '',
        from: value?.from || '',
        to: value?.to || ''
    }
}

function isStateDifferent(state1: DateRangeState | TimeRangeState, state2?: DateRangeState | TimeRangeState) {
    return state1.from !== state2?.from || state1.to !== state2?.to || (state1 as TimeRangeState).date !== (state2 as TimeRangeState)?.date
}

const DateRangeInput = ({ onChange, value, type }: DateRangeInputProps) => {

    let component = <></>

    const [state, setState] = React.useState<DateRangeState | TimeRangeState>(getStateFromValue(value));

    const onTimeRangeChange = (type: string, e: moment.Moment) => {
        const format = type === 'date' ? dateFormat : timeFormat
        setState({ ...state, [type]: e?.format(format) })
    }

    const onDateRangeChange = (type: string, e: moment.Moment) => {
        setState({ ...state, [type]: e?.format(dateFormat) })
    }

    React.useEffect(() => {
        onChange && onChange(state)
    }, [state]);

    React.useEffect(() => {
        const newState = getStateFromValue(value);
        if(isStateDifferent(newState, state)) {
            setState(newState)
        }
    }, [value]);

    if (type === 'daterange') {
        component = <div className='tp-daterange'>
            <div className='tp-daterange-wrapper me-3'>
                <label className=''>Dal</label>
                <Datetime locale='it' onChange={(e) => onDateRangeChange('from', e as moment.Moment)} utc dateFormat={dateFormat} timeFormat={false} renderInput={renderDateInput}
                    value={state?.from}
                />
            </div>
            <div className='tp-daterange-wrapper'>
                <label className=''>Al</label>
                <Datetime locale='it' onChange={(e) => onDateRangeChange('to', e as moment.Moment)} utc dateFormat={dateFormat} timeFormat={false} renderInput={renderDateInput}
                    value={state?.to}
                />
            </div>
        </div>
    } else if (type === 'timerange') {
        component = <div className='tp-timerange'>
            <label className=''>Data</label>
            <Datetime locale='it' onChange={(e) => onTimeRangeChange('date', e as moment.Moment)} utc dateFormat={dateFormat} timeFormat={false} renderInput={renderDateInput}
                value={(value as TimeRangeState)?.date}
            />
            <div className='tp-timerange-innerwrapper'>
                <div className='tp-timerange-wrapper me-3'>
                    <label className=''>Dalle</label>
                    <Datetime locale='it' onChange={(e) => onTimeRangeChange('from', e as moment.Moment)} utc dateFormat={false} timeFormat={timeFormat} renderInput={renderTimeInput}
                        value={(value as TimeRangeState)?.from}
                    />
                </div>
                <div className='tp-timerange-wrapper'>
                    <label className=''>Alle</label>
                    <Datetime locale='it' onChange={(e) => onTimeRangeChange('to', e as moment.Moment)} utc dateFormat={false} timeFormat={timeFormat} renderInput={renderTimeInput}
                        value={(value as TimeRangeState)?.to}
                    />
                </div>
            </div>
        </div >
    }

    return <div className='tp-input-date-wrapper'>{component}</div>
}
export default DateRangeInput;
